import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ListItem, ListItemButton, ListItemText, ListItemIcon } from "@mui/material";
import { EmptyCart, getFamilyCartData } from "../../../../Redux/Actions";
// import crossIcon from "../../../../Assets/svg/metroCross.svg"
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import mobileMenuStyles from "../MobileMenuDrawer/MobileMenuDrawer.module.css"
import mobileRadiologyStyles from "./MobileRadiology.module.css"
import Modal from "react-responsive-modal";

const MobileRadiology = ({ setOpenMobileMenuDrawer }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const familyCartDetails = useSelector((state) => state.getFamilyCartDataReducer.familyCartData);
  const [cartLength, setCartLength] = useState(0);
  const [openImg, setOpenImg] = useState(false);

  useEffect(() => {
    console.log("Family Cart Mobile", familyCartDetails);
    let len = 0;
    if (familyCartDetails?.length) {
      familyCartDetails.forEach((pack) => {
        len += pack?.members.length
      })
    }
    setCartLength(len);
  }, [familyCartDetails]);

  const onRadiologyClick = () => {
    if (cartLength) {
      setOpenImg(true);
      document.getElementById("mobile-menu").style.visibility = "hidden";
    } else {
      history.push("/imaging");
      // window.history.href = `${process.env.RAZZLE_APP_BASE_URL}/imaging`;
    }
  };

  const onCloseModalImg = () => {
    setOpenImg(false);
    setOpenMobileMenuDrawer(false);
  }

  const handleEmptyCartSubmit = () => {
    try {
      const userProfile = JSON.parse(localStorage.getItem("user"));
      const token = userProfile && userProfile.token;
      if (token) {
        dispatch(EmptyCart(token));
        setTimeout(() => {
          dispatch(getFamilyCartData(token));
          setOpenMobileMenuDrawer(false);
          history.push("/imaging");
          // window.location.href = `${process.env.RAZZLE_APP_BASE_URL}/imaging`;
        }, 400);
      } else {
        setOpenMobileMenuDrawer(false);
        history.push("/imaging");
        // window.location.href = `${process.env.RAZZLE_APP_BASE_URL}/imaging`;
      }
    } catch {
      setOpenMobileMenuDrawer(false);
      history.push("/imaging");
      // window.location.href = `${process.env.RAZZLE_APP_BASE_URL}/imaging`;
    }
  };

  return (
    <>
      {/* RADIOLOGY TAB */}
      <ListItem onClick={onRadiologyClick}>
        <ListItemButton className={mobileMenuStyles.listButton}>
          <ListItemText
            sx={{
              '& .MuiTypography-root': {
                fontSize: "2.3rem",
                fontFamily: "Jost",
                color: "#707070"
              }
            }}
          >
            Radiology
          </ListItemText>
          <ListItemIcon sx={{ alignSelf: "center", display: "flex", justifyContent: "flex-end" }}>
            <ArrowForwardIosIcon className={mobileMenuStyles.forwardIcon} />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>

      {/* MODAL TO SHOW IF CART IS NOT EMPTY  */}
      <Modal
        open={openImg}
        onClose={onCloseModalImg}
        center
        classNames={{
          modal: mobileRadiologyStyles.modal
        }}
      // closeIcon={crossIcon}
      >
        <div className={mobileRadiologyStyles.container}>
          <h2 className={mobileRadiologyStyles.ques}>
            Are you sure you want to empty your cart ?
          </h2>
          <div className={mobileRadiologyStyles.optionsDiv}>
            <span
              className={mobileRadiologyStyles.option}
              onClick={onCloseModalImg}
            >
              No
            </span>
            <span
              className={mobileRadiologyStyles.option}
              onClick={handleEmptyCartSubmit}
            >
              Yes
            </span>
          </div>
        </div>
      </Modal>

      {/* <Modal
        open={openImg}
        onClose={onCloseModalImg}
        center
        classNames={{
          overlay: "customFooterOverlay",
          modal: "customFooterModal",
        }}
      >
        <div onClick={onCloseModalImg} className="modalCloseButton">
          <img className="crossButton" src={metroCross} alt="" />
        </div>
        <div className="footer-modal">
          <h2>Are you sure you want to empty your cart ?</h2>
          <div className="modal-inner">
            <a href={process.env.RAZZLE_APP_BASE_URL} className="modal-link" onClick={onCloseModalImg}>
              No
            </a>
            <div className="modal-link" onClick={handleSubmit}>
              Yes{" "}
            </div>
          </div>
        </div>
      </Modal> */}
    </>
  );
}

export default MobileRadiology;